import { Client } from "@/Common/Api/Client";
import { Lab } from "@/Common/Api/Labs/Dto/Responses/Lab";
import { SearchLabResults } from "@/Common/Api/Labs/Dto/Responses/SearchLabresults";
import { IconButton } from "@/Common/Components/IconControls/IconControls";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { LabFacilityModel } from "@/Common/Models/Lab/LabFacilityModel";
import { GeographicInfoState } from "@/Common/Models/Localization/GeographicInfoState";
import * as ServerOperations from "@/Common/Operations/operations.server";

import LogoMyle from "@/Globals/_images/logo-myle.svg";

interface ILabSearchAutocomplete {
    onItemSelectCallback: (lab: LabFacilityModel) => void;
    onEditClickCallBack?: (item: LabFacilityModel) => void;

    focusOnMount?: boolean;
    searchOnMount?: boolean;
    componentId?: string;
    defaultText: string;
    onTextChangedFunction?: (s: string) => void;
    isRequired?: boolean;
    debounceOnTextChangeMS?: number;
    maxLength?: number;
}

class LabSearchAutocompleteState {
    public labResults: Lab[];
    public displayList: boolean;
    public text: string;
    public IsInEditCompnent: boolean;
    public response: boolean;

    public constructor(init?: LabSearchAutocompleteState) {
        Object.assign(this, init);
    }

    public static getDefault(text: string = ""): LabSearchAutocompleteState {
        return new LabSearchAutocompleteState({
            labResults: [],
            text,
            displayList: false,
            IsInEditCompnent: false,
            response: false
        });
    }
}

class LabSearchAutocomplete extends React.Component<ILabSearchAutocomplete, LabSearchAutocompleteState> {
    private timeoutSearchReference: number;
    private timeoutOnTextChangeReference: number;

    constructor(props: ILabSearchAutocomplete) {
        super(props);
        this.timeoutSearchReference = -1;
        this.timeoutOnTextChangeReference = -1;
        this.state = LabSearchAutocompleteState.getDefault(props.defaultText);
    }

    public componentDidUpdate(previousProps: ILabSearchAutocomplete): void {
        if (previousProps.defaultText != this.props.defaultText)
            this.mutateState(s => s.text = this.props.defaultText);
    }

    public componentDidMount(): void {
        if (this.props.focusOnMount == true) {
            window.setTimeout(
                () => {
                    $(`#${this.props.componentId}`).focus();
                    $(`#${this.props.componentId}`).select();
                },
                500
            );
        }
    }

    public render(): JSX.Element {
        const errorClass = !IsNullOrWhiteSpace(this.state.text) || this.props.isRequired === false ? "" : " has-error";

        return (

            <div id={"Parentdiv_" + this.props.componentId} className={"lab-autocomplete" + errorClass} onClick={e => e.stopPropagation()}>

                <textarea
                    id={this.props.componentId}
                    autoComplete="off"
                    key={this.props.componentId}
                    className="form-control"
                    onClick={this.TrottledExecuteSearch.bind(this, null)}
                    onFocus={this.onFocus.bind(this)}
                    onBlur={this.onblur.bind(this)}
                    onKeyDown={this.onKeyDown.bind(this)}
                    onChange={this.onTextChange.bind(this)}
                    value={this.state.text}
                    style={{ "maxWidth": "500px", "overflowX": "hidden", "overflowY": "hidden", "resize": "none", "height": "34px", "verticalAlign": "middle", "whiteSpace": "nowrap" }}
                    maxLength={this.props.maxLength}
                />

                {this.state.displayList && (
                    <div className="lab-results-ps">
                        <div id="scroll_container" className="lab-results-container" style={{ width: "100%", maxHeight: "500px" }}>
                            <ul className="lab-result-list">
                                {this.state.labResults.map((lab: Lab, i: number) => {
                                    let cssStyle: React.CSSProperties = {};
                                    if (lab.IsHighlighted == true)
                                        cssStyle = { backgroundColor: "#e4edfb" };

                                    let stateCode = GeographicInfoState.StaticGetStatePartOfSubdivisionCode(lab.Province);

                                    return (
                                        <li id={"li_lab_" + i} key={"li_lab_" + i}>

                                            <div className="lab-result" id={"lab_" + i} key={"lab_" + i} onClick={this.selectItem.bind(this, lab)} style={cssStyle}>

                                                {lab.IsApproved != null && <LogoMyle style={{ "height": "20px", "float": "left", "marginRight": "4px" }} id="_myleIconForApprovedLab" />}
                                                <div style={{ width: "90%", float: "left" }}> <h5>{lab.Name}</h5> </div>
                                                {lab.IsApproved == null && this.props.onEditClickCallBack && (
                                                    <IconButton
                                                        type="pen"
                                                        onClick={this.editItemLab.bind(this, lab)}
                                                        color="darkblue"
                                                    />
                                                )}

                                                <div />
                                                <div style={{ "width": "100%", "clear": "both" }}><p>{lab.Address}  {(lab.Address && lab.RegionNumber) && <span>-Reg</span>}{lab.RegionNumber} </p></div>

                                                <div />
                                                {lab.City}
                                                <div />
                                                {stateCode} {lab.PostalCode}
                                                <hr />
                                                <p><span>{MyleHelper.FormatPhone(lab.Phone, cacheStore.FindLookupByLookupCode(cacheStore.GetCountryLookupById_medfarDictionaries(lab.Country)).LookupCode)}</span>{(lab.Phone && lab.Fax) && <span className="separator">|</span>}<span>{MyleHelper.FormatPhone(lab.Fax, cacheStore.FindLookupByLookupCode(cacheStore.GetCountryLookupById_medfarDictionaries(lab.Country)).LookupCode)}</span></p>

                                            </div>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    </div>
                )}
            </div>
        );
    }

    private onTextChange(item: React.ChangeEvent<HTMLTextAreaElement>): void {
        let val = item.target.value;
        if (this.timeoutSearchReference !== -1) {
            clearTimeout(this.timeoutSearchReference);
            this.timeoutSearchReference = -1;
        }
        if (this.timeoutOnTextChangeReference !== -1) {
            clearTimeout(this.timeoutOnTextChangeReference);
            this.timeoutOnTextChangeReference = -1;
        }
        this.mutateState(
            s =>
                s.text = val,
            () => {
                this.timeoutSearchReference = window.setTimeout(() => {
                    if (!IsNullOrWhiteSpace(this.state.text))
                        this.TrottledExecuteSearch();
                }, 200);

                this.timeoutOnTextChangeReference = window.setTimeout(() => {
                    if (this.props.onTextChangedFunction != null)
                        this.props.onTextChangedFunction(val);
                }, this.props.debounceOnTextChangeMS ? this.props.debounceOnTextChangeMS : 400);
            }
        );
    }

    private TrottledExecuteSearch(selectedIndex?: number): void {
        // Throlle
        if (this.timeoutSearchReference !== -1) {
            clearTimeout(this.timeoutSearchReference);
            this.timeoutSearchReference = -1;
        }
        this.timeoutSearchReference = window.setTimeout(() => {
            this.ExecuteSearch(selectedIndex);
        }, 50);
    }

    private ExecuteSearch(selectedIndex?: number): void {
        let data = {
            SearchString: this.state.text,
            StateLookUpId: sessionStore.getCurrentEmployeeActiveSiteStateLookUpId()
        };

        if (IsNullOrWhiteSpace(this.state.text) || cacheStore.Helper.RemoveDiacritics(this.state.text).length < 2)
            return;

        Client.Post(ServerOperations.Server.MedfarDictionnary_SearchLabs, data, response => {
            let results: SearchLabResults = response;
            this.mutateState(s =>
                s.labResults = results.SearchLabResults
            );

            if (results.SearchLabResults.length > 0) {
                if (selectedIndex != null) {
                    this.selectItem(results.SearchLabResults[selectedIndex]);
                }
                else {
                    this.mutateState(s => s.displayList = true);
                }
            }
        }, error => { console.error(error); });
    }

    private selectItem(item: Lab): void {
        this.mutateState(s => {
            s.text = (item !== null) ? item.Name : "";
            s.displayList = false;
        }, () => { this.props.onItemSelectCallback(new LabFacilityModel(item)); });
    }

    private onFocus(): void {
        if (this.state.text != "") {
            if (this.state.labResults.length > 0 && !this.state.displayList) {
                this.mutateState(s =>
                    s.displayList = true
                );
            }
        }

        window.setTimeout(() => $("#" + this.props.componentId).select(), 50);
    }

    public onblur(): void {
        window.setTimeout(() => {
            this.mutateState(s =>
                s.displayList = false
            );
        }, 200);
    }

    private mutateState(mutation: (s: LabSearchAutocompleteState) => void, then: () => void = null): void {
        var lab = new LabSearchAutocompleteState();
        mutation(lab);
        if (then != null)
            this.setState(lab, then);
        else
            this.setState(lab);
    }

    private onKeyDown(e: React.KeyboardEvent): void {
        // up
        if (e.keyCode === 38) { e.preventDefault(); this.MoveSelectionUpOrDown(true); }

        // down
        if (e.keyCode === 40) { e.preventDefault(); this.MoveSelectionUpOrDown(false); }

        // enter
        if (e.keyCode === 13) {
            e.preventDefault();
            if (this.indexOfSelectedItem() != -1)
                this.selectItem(this.state.labResults[this.indexOfSelectedItem()]);
        }

        // shift + enter
        if (e.keyCode === 13 && e.shiftKey) {
            e.preventDefault();
        }

        if (e.keyCode === 27) {
            this.mutateState(s =>
                s.displayList = false
            );
        }
    }

    private MoveSelectionUpOrDown(IsDirectionUp: boolean): void {
        if (this.state.labResults == null)
            return;

        let collection = this.state.labResults;
        if (collection.length == 0)
            return;

        let idx = this.indexOfSelectedItem();
        if (idx === -1) { // None selected
            collection.forEach(x => x.IsHighlighted = false);
            collection[IsDirectionUp ? collection.length - 1 : 0].IsHighlighted = true;
            this.mutateState(s => s.labResults = collection, () => this.AdjustScroll());
            return;
        }

        // Top or bottom of list
        if ((idx === 0 && IsDirectionUp) || (idx === collection.length - 1 && !IsDirectionUp))
            return;

        collection[idx].IsHighlighted = false;
        idx = idx + (IsDirectionUp ? -1 : 1);

        collection[idx].IsHighlighted = true;
        this.mutateState(s => s.labResults = collection, () => this.AdjustScroll());
    }

    public AdjustScroll(): void {
        let idx = this.indexOfSelectedItem();

        let scrollParent = $("#scroll_container");
        let liSelected = $("#li_lab_" + idx);
        let firstItem = $("#li_lab_" + 0);
        if (scrollParent != null && liSelected != null && firstItem != null) {
            let scrollParentHeight = scrollParent.height();
            let CurrentScrollPosition = Math.abs(firstItem.position().top);

            let selectedItemRelativePosition = liSelected.position().top;
            let selectedItemHeight = liSelected.height();

            if (selectedItemRelativePosition < 0) // Item is above scoll position
                scrollParent.scrollTop(CurrentScrollPosition + selectedItemRelativePosition);
            else if (selectedItemRelativePosition + selectedItemHeight > scrollParentHeight) // Item is below scroll
                scrollParent.scrollTop(CurrentScrollPosition + (selectedItemRelativePosition + selectedItemHeight - scrollParentHeight)); // Add the offset to scroll position in order to fully include the last item
        }
    }

    private indexOfSelectedItem(): number {
        if (this.state.labResults == null || this.state.labResults.length == 0)
            return -1;

        for (var i = 0; i < this.state.labResults.length; i++) {
            var item = this.state.labResults[i];
            if (item.IsHighlighted == true) {
                return i;
            }
        }
        return -1;
    }

    private editItemLab(item: Lab): void {
        this.props.onEditClickCallBack?.(new LabFacilityModel(item));
    }
}

export { LabSearchAutocomplete };
